import Card from 'components/card'
import Image from 'components/image'
import Link from 'components/link'
import classNames from 'classnames'
import { track } from 'lib/analytics/track'
import css from './feed-items.scss'

export const AddItemsCardTile = ({
  img,
  name,
  onClick,
  url,
  trackingData: { registryId, registryOwnerId, currentUserId, isStoreCard },
}: AddItemsCardTileProps) => {
  const handleClick = () => {
    const eventProps = {
      eventType: 'Click',
      isRegistryOwner: registryOwnerId === currentUserId,
      registryOwnerId,
      registryId,
      eventUrl: window.location.href,
      eventLocation: 'Feed',
    }
    if (isStoreCard) {
      track.storeTileClicked({ ...eventProps, store: name })
    } else {
      track.brandTileClicked({ ...eventProps, brand: name })
    }
    onClick?.()
  }

  return (
    <Link onClick={handleClick} url={url} newWindow={!onClick}>
      {/* @ts-ignore */}
      <Card
        className={classNames(
          css.addItemsCardTile,
          'flex center phm phl-md pvs-md phxl-lg'
        )}
      >
        {img ? (
          <Image src={img} alt={name} />
        ) : (
          <span className="text-center text-bold text-brand-info">{name}</span>
        )}
      </Card>
    </Link>
  )
}

interface AddItemsCardTileProps {
  img?: string
  name: string
  onClick?: () => void
  url?: string
  trackingData: TrackingData
}

interface TrackingData {
  isStoreCard: boolean
  registryId: number
  registryOwnerId: number
  currentUserId: number
}
